import { defineMessages } from 'react-intl';

export default defineMessages({
  yourBorrows: { defaultMessage: 'Your borrows' },
  borrowed: { defaultMessage: 'Borrowed' },
  APYType: { defaultMessage: 'APY Type' },
});
